import './Keyboard.css';
import { useState, useEffect, useRef } from 'react';

function Keyboard() {
  return (
    <div class="keyboard__container">
      <div class="keyboard__row">
        <button name="keyboard__key">Q</button>
        <button name="keyboard__key">W</button>
        <button name="keyboard__key">E</button>
        <button name="keyboard__key">R</button>
        <button name="keyboard__key">T</button>
        <button name="keyboard__key">Y</button>
        <button name="keyboard__key">U</button>
        <button name="keyboard__key">I</button>
        <button name="keyboard__key">O</button>
        <button name="keyboard__key">P</button>
      </div>
      <div class="keyboard__row">
        <button name="keyboard__key">A</button>
        <button name="keyboard__key">S</button>
        <button name="keyboard__key">D</button>
        <button name="keyboard__key">F</button>
        <button name="keyboard__key">G</button>
        <button name="keyboard__key">H</button>
        <button name="keyboard__key">J</button>
        <button name="keyboard__key">K</button>
        <button name="keyboard__key">L</button>
        <button name="keyboard__key">Ñ</button>
      </div>
      <div class="keyboard__row">
        <button name="keyboard__key">Z</button>
        <button name="keyboard__key">X</button>
        <button name="keyboard__key">C</button>
        <button name="keyboard__key">V</button>
        <button name="keyboard__key">B</button>
        <button name="keyboard__key">N</button>
        <button name="keyboard__key">M</button>
      </div>
      <div class="keyboard__row">
        <button name="keyboard__key--space">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </button>
      </div>
    </div>
  );
}

export {
  Keyboard
}
